import { Offering, Study, StudyId } from '@/shared/models/view/study-viewmodel';
import { IOffering, IStudy, IStudyId } from '@/shared/models/api/study-model';

export default class StudiesMapper {
    public mapStudy(study: IStudy): Study {
        return new Study(
            study.id,
            study.description,
            study.noAdmissionOnPortal
        )
    }

    public mapOffering(offering: IOffering): Offering {
        return new Offering(
            offering.periodId,
            offering.description,
            offering.year
        )
    }

    public mapStudyId(studyId: IStudyId): StudyId {
        return new StudyId(
            studyId.studyId
        )
    }
}